import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "profileWrapper" }
const _hoisted_2 = { class: "main-scroll-wrap" }

import ScreenHeader from '@/components/ui/ScreenHeader.vue'
import ProfileForm from '@/components/profile-preferences/ProfileForm.vue'
import LastfmIntegration from '@/components/profile-preferences/LastfmIntegration.vue'
import PreferencesForm from '@/components/profile-preferences/PreferencesForm.vue'
import ThemeList from '@/components/profile-preferences/ThemeList.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileScreen',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(ScreenHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("设置")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ThemeList)
    ])
  ]))
}
}

})